import React, { useEffect, useState } from "react";
import "./ReportsTable.css";
import { ReportDto } from "../../Items/ReportDto";
import ReportService from "../../Services/ReportService";

// הגדרת טיפוס לאמצעי התשלום מהשרת
interface PaymentOption {
  id: number;
  optionName: string;
}

interface ReportsTableProps {
  searchTerm: string;
}

const ReportsTable: React.FC<ReportsTableProps> = ({ searchTerm }) => {
  const [data, setData] = useState<ReportDto[]>([]);
  // סטייט חדש לשמירת רשימת אמצעי התשלום מהשרת
  const [paymentMethods, setPaymentMethods] = useState<PaymentOption[]>([]);

  // טעינת הנתונים הראשונית מהשרת
  useEffect(() => {
    const fetchData = async () => {
      try {
        // טעינת הדוחות
        const reports = await ReportService.getReports();
        setData(reports);

        // טעינת אמצעי התשלום מהשרת
        const methods = await ReportService.getPaymentOptions(); // ודא שמתודה זו קיימת ב-Service
        setPaymentMethods(methods);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);
  
  const filteredReports = data.filter((report: any) =>
    Object.values(report).some(val =>
      val && val.toString().toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  const changeConfirmPayment = async (id: number): Promise<void> => {
    // מוצאים את השורה הנוכחית כדי לבדוק אם נבחר אמצעי תשלום
    const currentRow = data.find(row => row.id === id);
    
    // בדיקה: אם לא נבחר אמצעי תשלום (או שהשדה לא קיים), נציג שגיאה ולא נמשיך לשרת
    if (!currentRow || !currentRow.paymentOptionId) {
      alert("שגיאה: חובה לבחור אמצעי תשלום לפני אישור!");
      return;
    }

    try {
      // 1. פנייה לשרת ושליחת ה-ID של הדוח יחד עם ה-ID של אמצעי התשלום
      const response = await ReportService.changeConfirmPayment(id, currentRow.paymentOptionId);

      if (response === 200) {
        // 2. עדכון ה-State של השורות בהצלחה
        setData(prevRows => 
          prevRows.map(row => 
            row.id === id ? { ...row, isPaymentConfirmation: true } : row
          )
        );
      }
    } catch (error) {
      console.error("שגיאה באישור התשלום:", error);
      alert("העדכון נכשל, נסה שנית");
    }
  };

  // בעת שינוי ה-Select, אנחנו מעדכנים גם את ה-ID וגם את ה-Name ב-State המקומי
  const handleMethodChange = (id: number, selectedIdStr: string) => {
    const selectedId = selectedIdStr ? parseInt(selectedIdStr) : null;
    const selectedMethod = paymentMethods.find(m => m.id === selectedId);

    setData(prev =>
      prev.map(row => 
        row.id === id 
          ? { 
              ...row, 
              paymentOptionId: selectedId, // שומרים את ה-ID בשביל השליחה לשרת
              paymentOptionName: selectedMethod ? selectedMethod.optionName : "" // לתצוגה במידת הצורך
            } 
          : row
      )
    );
  };

  const formatDate = (dateString: string) => {
    if (!dateString) return "— — —";
    return dateString.split("T")[0]; 
  };
  
  return (
    <>
      <div className="summary-bar">
        <div className="item">חשבון לחודש 05.2025</div>
        <div className="item">סה"כ: 40000</div>
        <div className="item">שולם: 22000</div>
        <div className="item">חוב: 18000</div>
      </div>
      <table className="reports-table">
        <thead>
          <tr>
            <th>מספר הזמנה</th>
            <th>תאריך הזמנה</th>
            <th>שם המזמין</th>
            <th>טלפון</th>
            <th>סכום הזמנה</th>
            <th>שולם בתאריך</th>
            <th>שולם באמצעות</th>
            <th>אישור תשלום</th>
          </tr>
        </thead>
        <tbody>
          {filteredReports.map(row => (
            <tr key={row.id}>
              <td>{row.id}</td>
              <td>{formatDate(row.orderDate)}</td>
              <td>{row.orderingCompanyName}</td>
              <td>{row.phone}</td>
              <td className={row.isPaymentConfirmation ? "" : "highlight"}>{row.orderAmount}</td>
              <td>{formatDate(row.paymentDate)}</td>
              <td>
                <select
                  className="method-select"
                  disabled={row.isPaymentConfirmation} // חוסם את השינוי אם התשלום כבר אושר
                  value={row.paymentOptionId || ""} // ה-value כעת מבוסס על ה-ID הייחודי
                  onChange={e => handleMethodChange(row.id, e.target.value)}
                >
                  <option value="">בחר אמצעי תשלום</option>
                  {paymentMethods.map(method => (
                    <option key={method.id} value={method.id}>
                      {method.optionName}
                    </option>
                  ))}
                </select>
              </td>
              <td>
                {row.isPaymentConfirmation ? (
                  <button className="approved-btn" disabled>תשלום אושר</button>
                ) : (
                  <button
                    onClick={() => changeConfirmPayment(row.id)} 
                    className="approve-btn"
                  >
                    אשר תשלום
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
};

export default ReportsTable;